// extracted by mini-css-extract-plugin
export default {"modalOverlay":"vD-z","modalContent":"wD-z","header":"xD-z","close":"yD-z"};